import { Injectable }                       from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { GenericException } from '../../exceptions/generic.exception';
import { CompanyName } from 'src/app/business/models/master/company/company-name.model';
import { AdminGuideService } from 'src/app/business/services/admin/guide.service';


@Injectable({
  providedIn: 'root'
})
export class AdminGuideInteractor {

    constructor(private adminGuideService: AdminGuideService) {
    }

    getGuidesNames(providerId: number): Observable<Array<CompanyName>> {

        return Observable.create((observer: Observer<Array<CompanyName>>) => {
            this.adminGuideService.getGuidesNames(providerId)
                  .subscribe(
                      (guides: Array<CompanyName>) => {

                          observer.next(guides);
                          observer.complete();
                      },
                      (error: GenericException) => {
                          observer.error(error);
                      }
                  )

        });
    }

}